import { useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { useCmApi } from "./useCmApi"

export function useRequestAccess() {
  const [showAlert, setShowAlert] = useState(false)

  const cmApi = useCmApi()
  const mutation = useMutation({
    mutationFn: cmApi.createAccessRequest
  })

  const handleRequestAccess = () => {
    mutation.mutate(undefined, {
      onSuccess: () => {
        setShowAlert(true)
      },
      onError: () => {
        setShowAlert(true)
      }
    })
  }

  const alertIsSuccess = mutation.isSuccess

  return {
    handleRequestAccess,
    showAlert,
    setShowAlert,
    alertIsSuccess,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess
  }
}
